import React, { useRef, useEffect, Component } from "react"
import Navbar from "./Navbar/index.js"
import { Flipper } from "react-flip-toolkit"
import DropdownContainer from "./DropdownContainer/index.js"
import { Icon, DropdownSection, Heading } from "./DropdownContents/Components.js"
import * as rsuite from 'rsuite'
import styled from "styled-components"
import * as General from '../Business/General/General.js'
import { useNavigate } from 'react-router-dom'
import UserProperty from "./UserProperty.js"
import LogOut from "./LogOut.js"
import { BasketContext } from "../Business/Context/BasketContext.js";
import * as BiIcon from "react-icons/bi"

// import BasketIcon from "../Business/Basket/BasketShow.js"

const NavbarItemTitle = styled.button`
  background: transparent;
  border: 0;
  font-weight: bold;
  font-size: 13px;
  padding: 2rem 1.5rem 1.2rem 1.5rem;
  text-color: secondary;
  display: flex;
  justify-content: center;
  transition: opacity 250ms;
  cursor: pointer;
  /* position above the dropdown, otherwise the dropdown will cover up the bottom sliver of the buttons */
  position: sticy;
  z-index: 200;
  &:hover, &:focus {
    opacity: 0.7;
    outline:none;
  }
`
const NavbarItemEl = styled.li`
   position: relative;

`


const DropdownSlot = styled.div`
  position: absolute;
  left: 40%;
  transform: translateX(-50%);
  perspective: 1500px;
  
`

//#region Product



const SubProductsList = styled.ul`
li {
  display: flex;
  margin-bottom: 1rem;
}
h3 {
  margin-right: 1rem;
  width: 29rem;
  display: block;
}
a {
  color: var(--dark-grey);
}
`

const ProductsSection = styled.ul`
li {
  display: flex;
}
  overflow-y: auto !important;
	scroll-snap-type: y mandatory !important;
	overflow-x: hidden;
  max-height: 70vh !important;
`
//#endregion
const AnimatedNavbar = (props) => {
  const navigate = useNavigate();
  const [state, setState] = React.useState({ activeIndices: [] })
  const [animatingOutTimeout, setanimatingOutTimeout] = React.useState(0)
  const [currentIndex, setcurrentIndex] = React.useState(-1)
  // const [RemainCount, seRemainCount] = React.useState(1);

  const [ProductGroupId, setProductGroupId] = React.useState(-1)
  const [BasketItemCount, setBasketItemCount] = React.useState(0)
  const [PhotoTag, setPhotoTag] = React.useState("")
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  // const BasketRef = React.useContext(BasketContext);
  const handleLoad = () => {
    setLoading(false);
  };

  const DivEl = styled.div`
  margin: 25px;
  position: fixed;
  z-index:100;
  left:0
  `

  const handleError = (e) => {
    console.dir(e)
    setLoading(false);
    setError(true);
  };



  const resetDropdownState = i => {
    setState({
      activeIndices: i !== -1 ? [i] : [],
      animatingOut: false
    })
  }

  const onMouseEnter = i => {
    setcurrentIndex(i)

    if (animatingOutTimeout) {
      clearTimeout(animatingOutTimeout)
      resetDropdownState(i)
      return
    }
    if (state.activeIndices[state.activeIndices.length - 1] === i)
      return

    setState(prevState => ({
      activeIndices: prevState.activeIndices.concat(i),
      animatingOut: false
    }))
  }

  const onMouseLeave = () => {
    setcurrentIndex(-1)
    setProductGroupId(-1)
  }

  const { duration } = props.duration
  let direction


  const NavigatePage = (url) => {

    window.location.href = url;
  }


  const { basketRef, count, setCount } = React.useContext(BasketContext);

  // وقتی میخوای count رو بگیری و badge رو آپدیت کنی:
  const updateBasketCount = async () => {
    basketRef.current.GetCount().then(count => setBasketItemCount(count));

  };


  useEffect(() => {
    updateBasketCount();
  }, [updateBasketCount]);

  return (
    <Flipper
      flipKey={currentIndex}
      spring={"noWobble"}
    >
      <Navbar onMouseLeave={onMouseLeave}>
        {/*  */}
        <a onClick={() => NavigatePage("/")} title="خانه" className="Cursor">
          <img src="../../../../../../assets/images/Logo.png" style={{ width: 30, height: 30, marginTop: 20 }} />
        </a>


        <NavbarItemEl>
          <NavbarItemTitle onMouseEnter={() => onMouseEnter(0)} onMouseOver={() => onMouseEnter(0)} > محصولات</NavbarItemTitle>
          <DropdownSlot>

            {currentIndex === 0 && (
              <DropdownContainer
                direction={direction}
                animatingOut={state.animatingOut}
                duration={duration}
              >
                <div className='bg-white' style={{
                  width: (ProductGroupId === -1 ? "25rem" : "55rem"),
                  marginRight: (ProductGroupId === -1 ? "5rem" : "35rem")
                }} >
                  <rsuite.Row>
                    <rsuite.Col xs={ProductGroupId === -1 ? "24" : "12 "}>
                      <DropdownSection data-first-dropdown-section>
                        <ProductsSection  >
                          <rsuite.Accordion defaultActiveKey={ProductGroupId}>
                            {props.value[0].map((group) =>

                              <rsuite.Accordion.Panel className="FarmAsan-text-success" header={group.title}
                                eventKey={group.id} onClick={() => (setProductGroupId(group.id), setPhotoTag(group.photoTag))} >

                                {group.children.map((child) =>
                                  <>
                                    <p className="Cursor Hover"

                                      onClick={() => {
                                        const groupSlug = General.toSlug(group.title, { latin: true });
                                        const childSlug = General.toSlug(child.title, { latin: true });

                                        const childPart = (groupSlug === childSlug)
                                          ? childSlug
                                          : childSlug.replace(groupSlug, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");

                                        NavigatePage(`/Product/${groupSlug}/${childPart}/${group.id}/${child.id}`);
                                      }}>

                                      <rsuite.Avatar className="ms-2" size="sm" circle src={General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + group.id + '' + PhotoTag + '.jpg'} alt={General.toSlug(group.title)} />
                                      {child.title}
                                    </p >
                                    <hr className="hr-Fade"></hr>
                                  </>

                                )}

                              </rsuite.Accordion.Panel>

                            )}
                          </rsuite.Accordion>
                          <a onClick={() => NavigatePage("/ParentGroup")} className="  fw-bold FarmAsan-text-success">
                            <p className="mt-3 pt-2 Cursor Hover  text-start fw-bold">
                              مشاهده تمام دسته بندی محصولات ...
                            </p>
                          </a>

                        </ProductsSection>
                      </DropdownSection>

                    </rsuite.Col>
                    <rsuite.Col xs={ProductGroupId === -1 ? "24" : "12"} >
                      <div className={ProductGroupId === -1 ? "hide " : "p-2"}>

                        <rsuite.Image
                          src={General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + ProductGroupId + '' + PhotoTag + '.jpg'}
                          fallbackSrc="../../assets/images/ProductGroupPrefer.jpg"
                          alt={PhotoTag}
                          placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: 'auto' }} />
                          }
                          style={{ width: '100%', height: 'auto' }}
                          className="border-radius-half"
                        />


                      </div>
                    </rsuite.Col>
                  </rsuite.Row>


                </div>
              </DropdownContainer>
            )}

          </DropdownSlot>
        </NavbarItemEl>
        <NavbarItemEl className="hide">
          <NavbarItemTitle onMouseEnter={() => onMouseEnter(1)} onFocus={() => onMouseEnter(1)}> خدمات پس از فروش</NavbarItemTitle>
          <DropdownSlot>

            {currentIndex === 1 && (
              <DropdownContainer
                direction={direction}
                animatingOut={state.animatingOut}
                duration={duration}
              >
                <div className='bg-white' style={{
                  width: "30rem",
                  marginRight: "20rem"
                }}  >

                  <DropdownSection>
                    <SubProductsList>
                      <li>
                        <Heading noMarginBottom>Sigma</Heading>
                        <div>Your business data at your fingertips.</div>
                      </li>
                      <li>
                        <Heading noMarginBottom>Atlas</Heading>
                        <div>The best way to start an internet business.</div>
                      </li>
                      <li>
                        <Heading noMarginBottom>Radar</Heading>
                        <div>Fight fraud with machine learning.</div>
                      </li>
                    </SubProductsList>
                    {/* <WorksWithStripe>
                          <Heading noMarginBottom>
                            <a href="/">
                              <Icon /> Works with Stripe
                            </a>
                          </Heading>
                        </WorksWithStripe> */}
                  </DropdownSection>
                </div>
                {/* <CurrentDropdown /> */}
              </DropdownContainer>
            )}

          </DropdownSlot>
        </NavbarItemEl>
        <NavbarItemEl>
          <NavbarItemTitle onMouseEnter={() => onMouseEnter(2)} onMouseOver={() => onMouseEnter(2)} > برند محصولات</NavbarItemTitle>
          <DropdownSlot>

            {currentIndex === 2 && (
              <DropdownContainer
                direction={direction}
                animatingOut={state.animatingOut}
                duration={duration}
              >

                <div className='bg-white' style={{
                  width: "20rem",
                  marginRight: "-50px"
                }} >
                  <rsuite.Row>
                    <rsuite.Col xs={24}>
                      <DropdownSection data-first-dropdown-section>
                        <ProductsSection  >
                          {props.value[1].map(brand => (
                            <div onClick={() => NavigatePage(brand.id != -1 ? "/ProductBrand/" + General.toSlug(brand.title) + "/" + brand.id : "/Brand")} className="mb-0 p-0 fw-bold FarmAsan-text-success">
                              <p className={brand.id != -1 ? "Cursor Hover" : "Cursor Hover Font13 text-start fw-bold"}>
                                <rsuite.Avatar className={brand.id != -1 ? "ms-2" : "hide"} size="sm" circle src={General.ApiPhotoRoute() + 'Content/Images/BrandPhoto/' + brand.id + '.jpg'} alt={brand.title} />
                                {brand.title}
                              </p>
                              <hr className={brand.id != -1 ? "hr-Fade" : 'hide'}></hr>
                            </div>

                          ))}
                        </ProductsSection>
                      </DropdownSection>

                    </rsuite.Col>

                  </rsuite.Row>
                </div>


              </DropdownContainer>
            )}

          </DropdownSlot>
        </NavbarItemEl>

        <NavbarItemEl className="hide">
          <NavbarItemTitle >مقایسه محصولات </NavbarItemTitle>
        </NavbarItemEl>
        <NavbarItemEl onClick={() => NavigatePage("/MotorSuggestion")}>
          <NavbarItemTitle >پیشنهاد موتور برق  </NavbarItemTitle>
        </NavbarItemEl>
        <NavbarItemEl onClick={() => NavigatePage("/CompareProduct")}>
          <NavbarItemTitle >مقایسه محصولات </NavbarItemTitle>
        </NavbarItemEl>
        <NavbarItemEl onClick={() => NavigatePage("/AboutUs")}>
          <NavbarItemTitle >درباره ما</NavbarItemTitle>
        </NavbarItemEl>
        <NavbarItemEl onClick={() => NavigatePage("/ContactUs")} >
          <NavbarItemTitle >تماس با ما</NavbarItemTitle>
        </NavbarItemEl>




      </Navbar >
      <DivEl >

        <UserProperty></UserProperty>
        <LogOut></LogOut>
        <rsuite.Badge color='green' right content={count || false}>
          <BiIcon.BiBasket onClick={() => { basketRef.current?.Show(); updateBasketCount() }} className="fw-bold Font25 m-2" />
        </rsuite.Badge>

      </DivEl>
    </Flipper >
  )

}

export default AnimatedNavbar;
